<!-- 搜索部门树弹窗： 1.学分统计：选择工作单位；2.培训选调：选择选调范围 -->
<template>
  <el-dialog
    title="专题详情"
    class="rc-dialog"
    :visible.sync="detailDialog.flag"
    :close-on-click-modal="true"
    :destroy-on-close="true"
    width="60%"
  >
    <div v-loading="loading">
      <selct-header :tabs="tabs" @tabChage="tabChage" />
      <div class="table-container" v-loading="tableLoading" >
        <ResourceTable v-if="list && list.length > 0" :type="type" :data="list"  />
        <div v-else class="empty-view">
          暂无数据
        </div>
        <div class="RCPagination">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 50, 100, 500, 1000]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
        </div>
      </div>
      
    </div>
    
  </el-dialog>
</template>

<script>

import { subjectBlockList, subjectResourceInfo } from "@/api/subjectInfo";
import SelctHeader from "../selctHeader.vue";
import ResourceTable from "./resourceTable";

export default {
  components: { 
    SelctHeader,
    ResourceTable
  },
  props: {
    detailDialog: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      tableLoading: false,
      tabs: [],
      activeName: '',
      page: 1,
      limit: 10,
      total: 0,
      list: [],
      type: 0,
      subjectBlockId: '',

    };
  },
  created() {
    this.getBlockList();
  },
  methods: {
    getBlockList(flag) {
      this.loading = true;
      subjectBlockList({subjectId: this.detailDialog.subjectId}).then(({code, data}) => {
        this.loading = false;
        if (code != 0) return;
        if (data && data.length > 0) {
          this.tabs = data.map(item => {
            return {paramName: item.blockName, ...item}
          });
          this.tabChage(this.tabs[0])
        }
        
      })
    },

    tabChage(val) {
      this.activeName = val.paramName;
      this.type = val.blockType;
      this.subjectBlockId = val.uuid;
      // 获取详情
      this.queryList();
    },
    queryList() {
      this.tableLoading = true;
      this.list = [];
      subjectResourceInfo({
        page: this.page,
        limit: this.limit,
        subjectBlockId: this.subjectBlockId,
        studyStartTime: this.detailDialog.studyStartTime,
        studyEndTime: this.detailDialog.studyEndTime,
        deptId: this.detailDialog.deptId
      }).then(({code, data}) => {
        this.tableLoading = false;
        if (code != 0) return;
        this.list = data.records;
        this.total = data.total;
      })
    },
    handleSizeChange(s) {
      this.limit = s;
      this.page = 1;
      this.queryList();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.queryList();
    },
  }
}

</script>

<style lang="scss" scoped>

.table-container {
  padding: 20px 24px;
}

.rc-dialog {
  /deep/.el-dialog__body {
    padding: 0 !important;
    max-height: 500px;
  } 
}
.empty-view {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center; 
}

</style>